/**
 * Core
 */

import { ticketRoutes } from '@core/router/routeNames';

/**
 * Types
 */

import { TicketPermission } from '@generatedTypes';
import type { TicketRoute } from '@modules/tickets/access/ticketRouteAccess';

const {
  TICKET_GENERAL_INFORMATION,
  TICKET_ATTENDEES,
  TICKET_ADVANTAGES_PLANNED,
  TICKET_ADVANTAGES_ACTUAL,
  TICKET_CONTRACT_MANAGEMENT,
  TICKET_ATTENDEE_CONTRACT_PREVIEW,
  TICKET_SIGNING,
  TICKET_SIGNING_SHEET,
  TICKET_DEPOSIT_MANAGEMENT,
  TICKET_DEPOSIT_MANAGEMENT_INFOS,
  TICKET_DEPOSIT_INFO,
  TICKET_INFO,
  TICKET_INFO_ATTENDEE,
  TICKET_HISTORY,
} = ticketRoutes;

/**
 * The single route -> permission table. `null` means the route is readable when
 * {@link TicketAccessContext.isTicketUser} is true.
 */
const ticketRoutePermissions: Record<TicketRoute, TicketPermission | null> = {
  [TICKET_GENERAL_INFORMATION]: TicketPermission.EditInformation,
  [TICKET_ATTENDEES]: TicketPermission.EditAttendees,
  [TICKET_ADVANTAGES_PLANNED]: TicketPermission.EditPlannedAdvantages,
  [TICKET_ADVANTAGES_ACTUAL]: TicketPermission.EditActualAdvantages,
  [TICKET_CONTRACT_MANAGEMENT]: TicketPermission.EditContractManagement,
  [TICKET_ATTENDEE_CONTRACT_PREVIEW]: TicketPermission.EditContractManagement,
  [TICKET_SIGNING]: TicketPermission.EditSigning,
  [TICKET_SIGNING_SHEET]: TicketPermission.EditSigningSheet,
  [TICKET_DEPOSIT_MANAGEMENT]: TicketPermission.EditDeposit,
  [TICKET_DEPOSIT_MANAGEMENT_INFOS]: TicketPermission.EditDeposit,
  [TICKET_DEPOSIT_INFO]: null,
  [TICKET_INFO]: null,
  [TICKET_INFO_ATTENDEE]: null,
  [TICKET_HISTORY]: null,
};

export { ticketRoutePermissions };
